// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Mvh6","sendOtp":"AuthorizeToLogin_sendOtp__2k_Oa"};